<script setup lang="ts">
import { mdiFire } from '@quasar/extras/mdi-v7';
defineProps<{ streak: number; longestStreak: number }>();
</script>
<template>
  <div class="stat-card acc-streak">
    <div class="stat-card__head">
      <div class="stat-card__title">{{ $t('CURRENT_STREAK') }}</div>
      <div class="stat-badge">
        <q-icon
          :name="mdiFire"
          size="22px"
        />
      </div>
    </div>
    <div class="col column justify-center q-mt-sm">
      <div class="stat-value">{{ streak }}</div>
      <div class="stat-sub q-mt-xs">
        {{ $t('LONGEST_STREAK') }}: {{ longestStreak }}
      </div>
    </div>
  </div>
</template>
